import { bankersRoundWithMax } from '@/utils/utils'
import { usePlugin } from '@/hooks/usePlugin'
import { useRouter } from 'vue-router'
import { useCurrencyStore } from '@/pinia/currency'
import { useCart } from './useCart'
import { removeCart } from '@/api/cart'
import { useCartStore } from '@/pinia/cart'

export const useCartSpu = (spu) => {
  const { $toast, $confirm } = usePlugin()

  const router = useRouter()

  const cartStore = useCartStore()

  const { cartList, isProcessing, updateSkuPrice } = useCart()

  const currency = useCurrencyStore()

  const allProcessing = computed(() => spu.value.skuDetails.every(item => item.cartStatus === 0))

  const isBelowMOQ = computed(() => {
    const selectedCount = spu.value.skuDetails.reduce((sum, sku) => sku.checked ? sum + sku.quantity : sum, 0)
    return selectedCount > 0 && selectedCount < spu.value.batchNum
  })

  const selectVariants = computed(() => {
    let v = 0
    spu.value.skuDetails.forEach(item => {
      if (item.checked) v++
    })
    return v
  })

  const checkedSkuTotalCounts = computed(() => {
    let v = 0
    spu.value.skuDetails.forEach(item => {
      if (item.checked) {
        v += item.quantity
      }
    })
    return v
  })

  const hasProcessingInChecked = computed(() => {
    return spu.value.skuDetails.some(item => item.checked && isProcessing(item.cartStatus))
  })

  const totalItemsPrice = computed(() => {
    const checkedSkuList = spu.value.skuDetails.filter(item => item.checked)
    let price = 0
    checkedSkuList.forEach(item => {
      const targetPrice = bankersRoundWithMax(item.price * currency.current.rate, 0.01)
      price += targetPrice * item.quantity
    })
    return price.toFixed(2)
  })

  const shippingCost = computed(() => {
    const checkedSkuList = spu.value.skuDetails.filter(item => item.checked)
    if (checkedSkuList.length === 0) return '0.00'
    return spu.value.shipAmount ?? '0.00'
  })

  const subtotal = computed(() => {
    const v = Number(totalItemsPrice.value) + Number(shippingCost.value)
    return v.toFixed(2)
  })

  watchEffect(() => {
    const skuDetails = spu.value.skuDetails
    if (spu.value.disabled) return
    const isAllDisabled = skuDetails.every(item => item.disabled)
    spu.value.disabled = isAllDisabled
    spu.value.checked = isAllDisabled ? false : skuDetails.every(item => item.disabled || item.checked)
    updateSkuPrice(spu.value.offerId)
  })

  const handleCheck = () => {
    spu.value.checked = !spu.value.checked
    spu.value.skuDetails.forEach(item => {
      if (!item.disabled) {
        item.checked = spu.value.checked
      }
    })
  }

  const handleDelete = () => {
    $confirm('Delete item?', 'Are you sure you want to delete item from cart?').then(async () => {
      const cartIds = spu.value.skuDetails.map(item => item.cartId)

      const { code } = await removeCart({
        cartIds
      })
      if (code === 200) {
        cartStore.updateCartCount()
        $toast('Deleted successfully.', { type: 'success' })
        cartList.value.splice(cartList.value.indexOf(spu.value), 1)
      }
    })
  }

  const goDetailPage = (model) => {
    const { href } = router.resolve({
      path: `/offer/${model.offerId}`
    })

    window.open(href, '_blank')
  }

  return {
    isBelowMOQ,
    allProcessing,
    selectVariants,
    checkedSkuTotalCounts,
    hasProcessingInChecked,
    totalItemsPrice,
    shippingCost,
    subtotal,
    handleCheck,
    handleDelete,
    goDetailPage
  }
}
